import { Navigate, useLocation } from "react-router-dom";
import { APP_HOME_PATH } from "../config/routes";

/**
 * Redirects deep links to modules that are not in Phase 1 back to the app home.
 */
export default function Phase1OutOfScopeRedirect() {
  const { pathname } = useLocation();
  return <Navigate to={APP_HOME_PATH} replace state={{ phase1RedirectFrom: pathname }} />;
}
